import React, { useState, useEffect } from "react"
import Footer from "./components/Footer"
import Header from "./components/Header"
import Loading from "./components/Loading"
import StatusSummary from "./components/StatusSummary"
import ServiceContainer from "./components/ServiceContainer"
import MessagePanel from "./components/MessagePanel"
import WidthContainer from "./components/WidthContainer"

export default function App() {
	const [title, setTitle] = useState()
	const [logoURL, setLogoURL] = useState()
	const [latest, setLatest] = useState()
	const [timeline, setTimeline] = useState()
	const [today, setToday] = useState()

	const getTitleAndLogo = () => {
		fetch("/api/dashboard/title")
			.then(r => r.json())
			.then(r => {
				setTitle(r.response)
			})
		fetch("/api/dashboard/logo")
			.then(r => r.blob())
			.then(r => {
				let url = URL.createObjectURL(r)
				// Preload an invisible image to prevent flickering.
				// Instead, let the image preload and set the state afterwards
				// (which triggers the conditional re-render of the main page).
				let img = new Image()
				img.src = url
				img.onload = () => {
					setLogoURL(url)
				}
			})
	}

	const fetchApi = () => {
		fetch("/api/services/latest")
			.then(r => r.json())
			.then(r => {
				setLatest(r.response)
			})
		fetch("/api/services/timeline")
			.then(r => r.json())
			.then(r => {
				setTimeline(r.response)
			})
		fetch("/api/services/today")
			.then(r => r.json())
			.then(r => {
				setToday(r.response)
			})
	}

	useEffect(() => {
		getTitleAndLogo()
		fetchApi()
		const interval = setInterval(() => {
			fetchApi()
		}, 30 * 1000 /* seconds */)
		return () => clearInterval(interval)
	}, [])

	const restructureDay = day => {
		const perService = {}
		for (const [name, status] of Object.entries(day.services)) {
			// append the status for a service and
			// slice in the "at" timestamp
			perService[name] = {
				at: day.at,
				...status,
			}
		}
		return perService
	}

	if (!title || !logoURL || !latest || !timeline || !today) {
		return <Loading />
	} else {
		// restructure the response from /api/services/timeline
		// so that every ServiceContainer component receives only
		// it's own timeline array containing only one service
		let serviceTimeline = {}
		timeline.forEach(day => {
			// iterates over every service reported in one day
			for (const [name, status] of Object.entries(restructureDay(day))) {
				// create the timeline array, if it does not exist
				if (!serviceTimeline[name]) {
					serviceTimeline[name] = []
				}
				serviceTimeline[name].push(status)
			}
		})
		// reconstruct today answer
		const todayPerService = restructureDay(today)

		return (
			<>
				<header id="header">
					<WidthContainer
						className="mb-8"
					>
						<Header 
							title={title}
							logoURL={logoURL}
							lastCheckTs={latest.at}
						/>
					</WidthContainer>
				</header>
				<main className="w-11/12 md:w-5/6 mx-auto">
					<div id="status-summary" className="mx-auto w-max">
						<StatusSummary latest={latest} />
					</div>
					<div id="messages">
						<MessagePanel />
					</div>
					<div id="services">
						{
							// map over the latest service report to calculate
							// the number of ServiceContainer components
							Object.entries(latest.services).map(([serviceName, latestStatus]) => (
								<WidthContainer 
									key={serviceName} 
									className="my-8"
								>
									<ServiceContainer
										name={serviceName}
										latest={latestStatus}
										timeline={serviceTimeline[serviceName] || []}
										today={todayPerService[serviceName] || {}}
									/>
								</WidthContainer>
							))
						}
					</div>
				</main>
				<footer id="footer">
					<Footer />
				</footer>
			</>
		)
	}
}